import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import SiteSubNav from 'containers/SiteSubNav';
import { selectors } from './../ducks/tree.duck';

/**
 * Recursively format children to fit required link structure for ListNav
 * @function
 * @param {Array} linkItems - An hierarchical structure returned from the
 * API with `menu=true` enabled.
 * @example
 * {
 *   title: 'Text title',
 *   to: {
 *     type: 'INFO',
 *     payload: { path: 'string/path' },
 *   },
 *   children: [{...}],
 * }
 */
const formatChildren = R.map(
  R.pipe(
    R.applySpec({
      id: R.prop('path'),
      title: R.prop('title'),
      to: {
        type: R.always('INFO'),
        payload: {
          path: R.pipe(
            R.prop('path'),
            // Removes leading slash, since it breaks the router's link
            // component.
            R.tail,
          ),
        },
      },
      children: R.prop('children'),
    }),
    // Look for children and apply the spec to them if present
    R.ifElse(
      R.propIs(Array, 'children'),
      R.evolve({
        children: x => formatChildren(x),
      }),
      // Don't leave any redundant children properties created by applySpec
      R.omit(['children']),
    ),
  ),
);

const getItems = createSelector(
  selectors.data,
  R.pipe(
    R.propOr([], 'children'),
    formatChildren,
  ),
);

const InfoNav = connect(R.applySpec({
  items: getItems,
}))(SiteSubNav);

export default InfoNav;
